import CategoryTag from "@/domain/enums/CategoryTag";

export type categoryRepartition = {
    categoryId: string;
    percentage: number;
    title: CategoryTag;
};

interface EmailViewSummaryProps {
    id: string;
    title: string;
    icon: string;
    iconColor?: string;
    mailCount: number;
    categoryRepartition: categoryRepartition[];
}

class EmailViewSummary {
    id: string;

    title: string;

    icon: string;

    iconColor?: string;

    mailCount: number;

    categoryRepartition: categoryRepartition[];

    constructor({
        id,
        title,
        icon,
        iconColor,
        mailCount,
        categoryRepartition,
    }: EmailViewSummaryProps) {
        this.id = id;
        this.title = title;
        this.icon = icon;
        this.iconColor = iconColor;
        this.mailCount = mailCount;
        this.categoryRepartition = categoryRepartition;
    }
}

export default EmailViewSummary;
